export default (value) => {
  if (value === null || value === undefined) {
    return '-';
  }

  if (Number.isNaN(value)) {
    return 0;
  }

  if (isNaN(value)) {
    return value;
  }

  const formatter = new Intl.NumberFormat('es-AR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(value);
};
